<template>
   <div>
       <form v-if="user === null" @submit.prevent="submit">
           <div>
               <h2>{{ $t("User panel") }}</h2>
               <FormInput class="mb-3" v-model="form.login" :error="form.errors.login" label="Login" name="login"
                          icon="fa-solid fa-user"/>
               <FormInput class="mb-3" v-model="form.password" :error="form.errors.password" label="Password"
                          name="password" type="password" icon="fa-solid fa-key"/>
               <div class="mb-3">
                   <Link preserve-scroll :href="route('forgot_password.form')">{{ $t("Forgot your password?") }}</Link>
               </div>
               <Button ref="loginButton" :disabled="form.processing" size="big">{{ $t("Login") }}</Button>
           </div>
       </form>
       <div v-else>
           <h2>{{ user.login }}</h2>
           <div class="grid grid-cols-2 gap-4 text-center p-4">
               <div class="border border-orange-900 bg-yellow-900 shadow-inner p-2">
                   <i class="fa-solid fa-coins"></i> {{ user.coins }}
               </div>
               <div>
                   <a :href="route('shop.coins.buy')">
                       <Button>{{ $t("Buy coins") }}</Button>
                   </a>
               </div>
           </div>
           <ul class="p-4">
               <li>
                   <Link preserve-scroll :href="route('user.home')">
                       <i class="fa-solid fa-user-group"></i> {{ $t("Account") }}
                   </Link>
               </li>
               <li>
                   <Link preserve-scroll :href="route('user.change_password')">
                       <i class="fa-solid fa-key"></i> {{ $t("Change password") }}
                   </Link>
               </li>
               <li>
                   <Link preserve-scroll :href="route('user.change_email')">
                       <i class="fa-solid fa-envelope"></i> {{ $t("Change email") }}
                   </Link>
               </li>
               <li v-if="config.vote4coins_v4c_enable">
                   <Link preserve-scroll :href="route('user.vote4coins.index')"><i class="fa-solid fa-trophy"></i> {{ $t("Vote server") }}</Link>
               </li>
               <li>
                   <Link preserve-scroll :href="route('logout')" method="post">
                       <i class="fa-solid fa-arrow-right-from-bracket"></i> {{ $t("Logout") }}
                   </Link>
               </li>
           </ul>
       </div>
   </div>
</template>

<script setup>
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import {computed, ref} from "vue";
import Button from "@/Shared/Button";
import FormInput from "@/Shared/FormInput";
import {Link} from '@inertiajs/inertia-vue3'

const loginButton = ref(null)
const form = useForm({
    login: null,
    password: null,
    captcha_token: null
})

const user = computed(() => usePage().props.value.user)
const config = computed(() => usePage().props.value.config)

function submit() {
    loginButton.value.toggleLoading()

    grecaptcha
        .execute(usePage().props.value.recaptcha_site_key, {action: 'login'})
        .then(function (token) {
            form.captcha_token = token
            form.post(route('login'), {
                preserveScroll: true,
                onFinish: () => loginButton.value.toggleLoading()
            })
        })
}
</script>
